import React from 'react';
import styles from './ArrowButton.module.scss';
import classNames from 'classnames';
import Link from 'next/link';
import { openInNewTab } from '@/components/button/button.helper';

export enum ArrowButtonType {
    WHITE = 'white',
    BLACK = 'black',
}

interface IArrowButton {
    children: React.ReactNode;
    type?: ArrowButtonType;
    isTargetBlank?: boolean;
    classes?: string;
    href?: string;
    onClick?(): void;
}

export const ArrowButton: React.FC<IArrowButton> = ({
    children,
    type = ArrowButtonType.WHITE,
    classes,
    href,
    onClick,
    isTargetBlank,
}) => {
    const arrowButtonStyles = classNames(styles.arrowButton, classes, {
        [styles.arrowButtonWhite]: type === ArrowButtonType.WHITE,
        [styles.arrowButtonBlack]: type === ArrowButtonType.BLACK,
    });
    const newTab = isTargetBlank ? openInNewTab(isTargetBlank) : '';

    return href ? (
        <Link className={arrowButtonStyles} href={href} target={newTab}>
            {children}
        </Link>
    ) : (
        <button className={arrowButtonStyles} onClick={onClick}>
            {children}
        </button>
    );
};
